import { Providers } from './providers';
import { Router } from './Router';

/** Composition only. Everything else lives in a feature or in shared/. */
export function App() {
  return (
    <Providers>
      <Router />
    </Providers>
  );
}
